import React, { useMemo } from "react";

import { type SalesPageMetric } from "@north-beam/nb-client-side";
import { MetricCustomizationModal } from "@shared/metric-customization-modal";
import { type MetricConfig } from "@shared/metric-customization-modal/metric-category-builder";

import { useSalesViews } from "../sales-views-context";

interface CustomizeChartMetricsModalProps {
  graphMetricBoxes: string[];
  setGraphMetricBoxes: (arg0: string[]) => void;
  customizableMetricsArray: SalesPageMetric[];
  setSelectedMetricIndices: (arg0: number[]) => void;
}

export const CustomizeChartMetricsModal = ({
  graphMetricBoxes,
  setGraphMetricBoxes,
  customizableMetricsArray,
  setSelectedMetricIndices,
}: CustomizeChartMetricsModalProps) => {
  const { saveSalesViewsSelectedMetricBoxes } = useSalesViews();

  const onSave = (newMetrics: MetricConfig[]) => {
    const metricsToDisplay = newMetrics
      .filter((metric) => metric.visible)
      .map((metric) => metric.name);
    setSelectedMetricIndices([0]);
    setGraphMetricBoxes(metricsToDisplay);
    saveSalesViewsSelectedMetricBoxes(metricsToDisplay);
  };

  const metrics = useMemo(
    () =>
      customizableMetricsArray.map((metric) => ({
        name: metric.name,
        id: metric.id,
        visible: graphMetricBoxes.includes(metric.name),
        isNonModal: metric.isNonModal,
        metric,
      })),
    [graphMetricBoxes, customizableMetricsArray],
  );

  return (
    <MetricCustomizationModal
      title="Customize chart metrics"
      subtitle="Hide/show and reorder metrics in the chart"
      metrics={metrics}
      onSave={onSave}
    />
  );
};
